import { useTranslations } from 'next-intl';
import { AtAGlanceModel } from './AtAGlance';
import Asia from '@/assets/maps/asia.svg';
import Europe from '@/assets/maps/europe.svg';
import Global from '@/assets/maps/global.svg';
import Northamerica from '@/assets/maps/northamerica.svg';
import Usa from '@/assets/maps/usa.svg';
import { encodeBase64 } from '@/utils';

type AtAGlanceMapModel = {
  mapModule: AtAGlanceModel['mapModule'];
  backgroundColour?: string;
};

const AtAGlanceMap = ({ mapModule, backgroundColour }: AtAGlanceMapModel) => {
  const t = useTranslations();

  if (!mapModule) return null;

  const { regionMap, countryCodes } = mapModule;

  const mapClassName = 'h-full w-full stroke-[2px] stroke-[#c4c4c4] fill-[#c4c4c4]';

  const mapFilter = `<svg width="50" viewBox="0 0 50 50" height="50" xmlns="http://www.w3.org/2000/svg"><g><ellipse stroke-width="28" stroke="${backgroundColour}" ry="29" rx="29" id="svg_2" cy="25" cx="25" fill="none"/></g></svg>`;

  const inlineStyle = `${countryCodes
    .split(',')
    .map((item) => `.map .${regionMap.toLowerCase()}_svg__${item.trim()}`)
    .join(', ')} {  fill: #58a658;  stroke: ##58a658;}`;

  return (
    <div className="flex w-full flex-col pl-6">
      <h3 className="my-4 h-7 text-lg leading-7 font-bold">{t('report.atAGlance.$regionalFocus')}</h3>
      <div className="relative">
        {regionMap && (
          <div className="map">
            {regionMap.toLowerCase() === 'asia' && <Asia className={mapClassName} />}
            {regionMap.toLowerCase() === 'europe' && <Europe className={mapClassName} />}
            {regionMap.toLowerCase() === 'global' && <Global className={mapClassName} />}
            {regionMap.toLowerCase() === 'northamerica' && <Northamerica className={mapClassName} />}
            {regionMap.toLowerCase() === 'usa' && <Usa className={mapClassName} />}
          </div>
        )}

        <style dangerouslySetInnerHTML={{ __html: inlineStyle }} />
        <div
          style={{
            backgroundImage: `url(data:image/svg+xml;base64,${encodeBase64(mapFilter)})`,
          }}
          className="absolute top-0 left-0 h-full w-full bg-size-[5px] bg-repeat xl:bg-size-[6px] print:hidden"
        ></div>
      </div>
    </div>
  );
};

export default AtAGlanceMap;
